/**
 * Distributors block: region tabs + collapsible countries.
 */
export function initSales() {
	const buttons = document.querySelectorAll( '.sales__filter [data-toggle]' );
	buttons.forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			const target = document.getElementById( button.dataset.toggle );
			if ( ! target ) {
				return;
			}
			document.querySelectorAll( '.card--sales' ).forEach( ( card ) => card.classList.remove( 'is-active' ) );
			buttons.forEach( ( b ) => b.classList.remove( 'is-active' ) );
			button.classList.add( 'is-active' );
			target.classList.add( 'is-active' );
		} );
	} );

	document.querySelectorAll( '.colapsable-item > .subheadline > button' ).forEach( ( toggle ) => {
		const panel = toggle.closest( '.colapsable-item' )?.querySelector( '.colapsable-item__content' );
		if ( ! panel ) {
			return;
		}
		toggle.addEventListener( 'click', () => {
			const expanded = toggle.getAttribute( 'aria-expanded' ) === 'true';
			toggle.setAttribute( 'aria-expanded', String( ! expanded ) );
			panel.hidden = expanded;
		} );
	} );
}
